import React, { Component } from 'react';
import * as S from './institucional.modal.styles';
import api from '../service/institucional.service';
import { Modal } from 'react-bootstrap';
import { connect } from '@common/components/base.component';

class Container extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      textoModal: undefined,
    };

    this.onClose = this.onClose.bind(this);
  }

  async componentDidMount() {
    const responseHabilitaMensagem = await api.getParametroHabilitaMensagem();
    const responseMensagem = await api.getParametroMensagem();

    Promise.all([responseHabilitaMensagem, responseMensagem]).then((values) => {
      this.setState({ showModal: values[0]?.data[0]?.Valor == 'S', textoModal: values[1]?.data[0]?.Valor });
    });
  }

  onClose() {
    this.setState({ showModal: false });
  }

  render() {
    const { showModal, textoModal } = this.state;

    return (
      <>
        <Modal
          className={'mt-5 mb-5'}
          show={showModal}
          onHide={this.onClose}
          enforceFocus={true}
          size="md"
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <S.ModalTitle>Mensagem</S.ModalTitle>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <S.ModalContainer>{textoModal}</S.ModalContainer>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default connect({
  actions: {},
  selectors: {},
})(Container);
